import { PRESTATION_TYPE_MES, PRESTATION_TYPE_CDF, VALID_PRESTATION_TYPES, IS_GAS } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

const getDataTypeText = (prestationType, t) => {
  if (prestationType === PRESTATION_TYPE_CDF) {
    return t('subscriptionForm:common.technical_contractual')
  }
  return t('subscriptionForm:common.technical')
}

const getProviderName = (energyType) => {
  return energyType === IS_GAS ? 'GRDF' : 'Enedis'
}

const getEnergyTypeText = (energyType, t) => {
  if (energyType === IS_GAS) {
    return t('subscriptionForm:common.gas')
  }
  return t('subscriptionForm:common.electricity')
}

const getAuthorizationTranslationKey = (energyType) => {
  if (energyType === IS_GAS) {
    return 'subscriptionForm:pce_module.meter_authorization.authorization_script'
  }
  return 'subscriptionForm:pdl_module.enedis_authorization.authorization_script'
}

export const getAuthorizationText = (t, prestationType, energyType) => {
  if (!prestationType || prestationType === '' || prestationType === '-1') {
    return ''
  }

  const validPrestationType = VALID_PRESTATION_TYPES.includes(prestationType) ? prestationType : PRESTATION_TYPE_MES

  const translationKey = getAuthorizationTranslationKey(energyType)
  const params = {
    provider: getProviderName(energyType),
    dataType: getDataTypeText(validPrestationType, t),
    energyType: getEnergyTypeText(energyType, t),
    time: new Date().toLocaleString('fr-FR')
  }

  return t(translationKey, params)
}
